const logins = {
    google: 'Google',
    xylem: 'Xylem Cloud',
    basic: 'a password',
    unknown: 'these credentials',
};
export default class MismatchedProviderError extends Error {
    provider;
    dpError;
    constructor(provider) {
        const login = logins[provider] || logins.unknown;
        const message = `This email is not configured to sign in with ${login}`;
        super(message);
        this.provider = provider;
        this.dpError = true;
    }
}
